import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { RolesPage } from '~/features/workspace/roles/roles-page';

/** `made`: the role just made, which carries New in the table. */
const search = z.object({ made: z.string().optional() });

function RolesRoute(): ReactElement {
  const { made } = Route.useSearch();
  // A role just made (or put back by Undo) reads the list afresh.
  return <RolesPage key={made ?? ''} made={made} />;
}

/** Every role of the workspace, and whose entries each sees (web-redesign-03 phase 2.1). */
export const Route = createFileRoute('/_app/business/roles/')({
  validateSearch: search,
  component: RolesRoute,
});
